import { render, staticRenderFns } from "./imgChatView.vue?vue&type=template&id=708101e6&scoped=true"
import script from "./imgChatView.vue?vue&type=script&lang=js"
export * from "./imgChatView.vue?vue&type=script&lang=js"
import style0 from "./imgChatView.vue?vue&type=style&index=0&id=708101e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708101e6",
  null
  
)

export default component.exports